import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedLayout } from "@/components/layout/ProtectedLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/CommandCenter";
import Branding from "@/pages/Branding";
import { applyTheme, getTheme } from "@/lib/theme";
import Records from "@/pages/Records";
import RecordNew from "@/pages/RecordNew";
import RecordDetail from "@/pages/RecordDetail";
import Certificate from "@/pages/Certificate";
import Committees from "@/pages/Committees";
import CommitteeRoom from "@/pages/CommitteeRoom";
import Approvals from "@/pages/Approvals";
import Notifications from "@/pages/Notifications";
import AuditLogs from "@/pages/AuditLogs";
import Users from "@/pages/Users";
import Backups from "@/pages/Backups";
import Profile from "@/pages/Profile";
import FormsHome from "@/pages/FormsHome";
import TemplateEditor from "@/pages/TemplateEditor";
import FormDataPage from "@/pages/FormData";
import Census from "@/pages/Census";
import EntryPrint from "@/pages/EntryPrint";
import MinutesList from "@/pages/MinutesList";
import MinutesEdit from "@/pages/MinutesEdit";
import MinutesPrint from "@/pages/MinutesPrint";
import AttendanceHistory from "@/pages/AttendanceHistory";
import Birthdays from "@/pages/Birthdays";

applyTheme(getTheme());

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/records" element={<Records />} />
        <Route path="/records/new" element={<RecordNew />} />
        <Route path="/records/:id" element={<RecordDetail />} />
        <Route path="/records/:id/certificate" element={<Certificate />} />
        <Route path="/committees" element={<Committees />} />
        <Route path="/committees/:id" element={<CommitteeRoom />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/approvals" element={<Approvals />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/audit-logs" element={<AuditLogs />} />
        <Route path="/users" element={<Users />} />
        <Route path="/backups" element={<Backups />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/forms" element={<FormsHome />} />
        <Route path="/forms/new" element={<TemplateEditor />} />
        <Route path="/forms/:id" element={<FormDataPage />} />
        <Route path="/forms/:id/edit" element={<TemplateEditor />} />
        <Route path="/forms/:id/rows/:rowId/print" element={<EntryPrint />} />
        <Route path="/attendance" element={<AttendanceHistory />} />
        <Route path="/birthdays" element={<Birthdays />} />
        <Route path="/census" element={<Census />} />
        <Route path="/minutes" element={<MinutesList />} />
        <Route path="/minutes/new" element={<MinutesEdit />} />
        <Route path="/minutes/:id" element={<MinutesEdit />} />
        <Route path="/minutes/:id/print" element={<MinutesPrint />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
